import { sendWebsocketMessage } from '../../../../../../App';

export function restartPersistingTradePlan(tradePlanId, restart) {
  const msg = {
    messageType: 'updateTradePlan',
    tradePlanId,
    field: 'restartPersistedTradePlan',
    value: restart,
  };
  sendWebsocketMessage(msg);
}
